export default "__VITE_ASSET__YrhGJZeX__"